import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    PGE: { label: i18n.t('companies.configuration_rec.pge'), value: '', labelValue: '' },
    DIR: { label: i18n.t('companies.configuration_rec.dir3_dire'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    // { field: 'idDir', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'DIR', title: i18n.t('companies.configuration_rec.dir3_dire'), columnMenu: 'myTemplate', locked: false },
    { field: 'PGE', title: i18n.t('companies.configuration_rec.pge'), columnMenu: 'myTemplate', locked: false }
  ]
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
